var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCohere = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cohere_svg__clip0_6235_341)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#39594D",
  fillRule: "evenodd",
  d: "M10.368 19.072c.853 0 2.56-.043 4.95-1.024 2.773-1.152 8.234-3.2 12.202-5.333 2.773-1.494 3.968-3.456 3.968-6.102C31.488 2.987 28.544 0 24.875 0H9.515C4.267 0 0 4.267 0 9.515s4.01 9.557 10.368 9.557",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D18EE2",
  fillRule: "evenodd",
  d: "M12.97 25.6c0-2.56 1.537-4.907 3.926-5.888l4.821-2.005C26.624 15.7 32 19.285 32 24.576A7.43 7.43 0 0 1 24.576 32h-5.248c-3.499 0-6.357-2.859-6.357-6.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7759",
  d: "M5.504 20.31C2.474 20.31 0 22.783 0 25.812v.726C0 29.525 2.475 32 5.504 32c3.03 0 5.504-2.475 5.504-5.504v-.725c-.043-2.987-2.475-5.462-5.504-5.462"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cohere_svg__clip0_6235_341"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCohere);
export default ForwardRef;